import { PatientTodayList } from "./components/patient-today-list/patient-today-list.js";
import "./components/patient-today-list-item/patient-today-list-item.js";
import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useLocalStorageProperly } from "../../../hooks/useLocalStorageProperly.js";
import { usePatientTodayList } from "./hooks/usePatientTodayList.js";
import { usePractitioners } from "./hooks/usePractitioners.js";
import { useLabels } from "./labels.provider.js";
import { selectedPractitionersSelector, selectedStatusesSelector, patientTodayListSelector } from "./patient-today-list-container.selectors.js";
import { withPatientTodayListProviders } from "./patient-today-list.providers.js";
import { AppointmentStatusFilter } from "./patient-today-list.types.js";
import QueryKeyProvider from "./query-key-provider.js";
import { EmployeeStatus } from "./types/practitioner.js";
import "react-virtuoso";
import "@mui/material";
import "../../../components/date-pickers/day-picker/day-picker.js";
import "@mui/icons-material/KeyboardArrowDown.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "@mui/icons-material/KeyboardArrowUp.js";
import "../../../constants/date/date.js";
import "date-fns";
import "../../../components/date-pickers/date-picker/date-picker.js";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../type/Translations.js";
import "date-fns/locale";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "@mui/material/Button/index.js";
import "@mui/material/styles";
import "@mui/x-date-pickers/internals/index.js";
import "../../../constants/create-theme/create-theme.js";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../components/text-field/text-field.styles.js";
import "../../../components/date-pickers/date-picker/theme/index.js";
import "../../../themes/date-calendar/date-calendar.js";
import "../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../themes/day-calendar/day-calendar.js";
import "../../../themes/filled-input/filled-input.js";
import "../../../themes/form-helper-text/form-helper-text.js";
import "../../../themes/form-label/form-label.js";
import "../../../themes/month-calendar/month-calendar.js";
import "../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../themes/pickers-day/pickers-day.js";
import "../../../themes/pickers-month/pickers-month.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../themes/pickers-year/pickers-year.js";
import "../../../themes/year-calendar/year-calendar.js";
import "../../../components/date-pickers/day-picker/day-picker.styles.js";
import "../../providers/UiLibraryThemeProvider.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/dialog/dialog.js";
import "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "../../../themes/icon-button/icon-button.js";
import "../../../themes/popover/popover.js";
import "../../../themes/tabs/tabs.js";
import "../../../themes/tooltip/tooltip.js";
import "./components/practitioner-select/practitioner-select.js";
import "lottie-react";
import "../../../components/avatar-group/avatar-group.styles.js";
import "@mui/system";
import "../../../components/dialog/dialog.js";
import "@mui/icons-material/Close.js";
import "../../../components/dialog/dialog.constants.js";
import "../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../components/icons/all/all.js";
import "../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../components/icons/MainIcon/MainIcon.js";
import "../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../components/icons/CardIcon/CardIcon.js";
import "../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../components/icons/EditIcon/EditIcon.js";
import "../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../components/icons/EventNote/EventNote.js";
import "../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../components/icons/ListIcon/ListIcon.js";
import "../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../components/icons/PinIcon/PinIcon.js";
import "../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../components/icons/WarningIcon/WarningIcon.js";
import "../../../components/label/label.styles.js";
import "../../../components/menu-item/menu-item.js";
import "@mui/material/MenuItem/index.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../components/menu-item/menu-item.styles.js";
import "../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../components/avatar/avatar.styles.js";
import "../../../components/slider/slider.styles.js";
import "../../../components/snackbar/snackbar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../components/snackbar/snackbar.types.js";
import "../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "../../../components/translations/utils.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "../../../components/time-select/time-select.styles.js";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../../components/time-interval-select/time-interval-select.styles.js";
import "@mui/material/Box/index.js";
import "../../components/appointments-picker/appointments-picker.styles.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "lodash";
import "./components/practitioner-select/components/practitioner-search.js";
import "./components/practitioner-select/components/practitioner-search.styles.js";
import "./components/practitioner-select/components/assets/Search.js";
import "./components/practitioner-select/practitioner-select.styles.js";
import "./components/practitioner-select/assets/icons/Arrow.js";
import "./components/practitioner-select/assets/icons/Employees.js";
import "./components/patient-today-list/patient-today-list.styles.js";
import "@mui/icons-material/Comment.js";
import "../../../components/styled-tooltip/styled-tooltip.js";
import "clsx";
import "../../components/appointments-picker/components/AvailableSlot/AvailableSlot.styles.js";
import "../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.styles.js";
import "../../components/appointments-picker/components/NextPeriod/NextPeriod.styles.js";
import "../../components/appointments-picker/components/PrevPeriod/PrevPeriod.styles.js";
import "../../components/appointments-picker/components/QuickFilter/QuickFilter.styles.js";
import "../../components/appointments-picker/components/TimeFrames/TimeFrames.styles.js";
import "../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.styles.js";
import "../../components/appointments-picker/components/WorkingDay/WorkingDay.styles.js";
import "../../components/chemistry-info/chemistry-info.js";
import "../../components/chemistry-info/chemistry-info.styles.js";
import "../../components/chemistry-info/components/ChemistryDot/ChemistryDot.js";
import "../../components/chemistry-info/constants.js";
import "../../components/chemistry-info/types.js";
import "../../components/chemistry-info/components/ChemistryDot/styles.js";
import "../../components/clinic-location-details/clinic-location-details.styles.js";
import "../../components/clinic-location-details/Day/styles.js";
import "../../components/clinic-location-details/Map/Map.js";
import "google-map-react";
import "../../components/floating-button/floating-button-container/styles.js";
import "../../components/floating-button/floating-button.styles.js";
import "../../components/news-section/news-section.styles.js";
import "../../components/obfuscated-text/obfuscated-text.js";
import "../../components/obfuscated-text/obfuscated-text.styles.js";
import "../../components/pain-details-form/pain-details-form.styles.js";
import "../../components/pain-details-form/constants/constants.js";
import "../../components/pain-details-form/types.js";
import "react-slick";
import "../../components/task-form/components/Avatar/Avatar.styles.js";
import "../../components/task-form/assets/icons/Avatar.js";
import "../../components/task-form/assets/icons/Logo.js";
import "../../components/task-form/components/Comments/Comments.styles.js";
import "../../components/task-form/assets/icons/Comment.js";
import "lodash/debounce.js";
import "../../components/task-form/components/DatePicker/DatePicker.styles.js";
import "../../components/task-form/components/EmployeeMenuItem/EmployeeMenuItem.styles.js";
import "../../components/task-form/components/EmployeesDropdown/EmployeesDropdown.styles.js";
import "../../components/task-form/components/PatientAutocomplete/PatientAutocomplete.styles.js";
import "@hookform/resolvers/yup";
import "../../components/task-form/task-form.entities.js";
import "yup";
import "../../components/task-form/task-form.helpers.js";
import "../../components/task-form/task-form.types.js";
import "../../components/task-form/task-form.styles.js";
import "../../components/task-form/assets/icons/Important.js";
import "../../components/task-form/assets/icons/TaskCategory.js";
import "../../components/task-form/assets/icons/TaskDescription.js";
import "../../components/task-form/assets/icons/TaskName.js";
import "../../components/task-form/theme/index.js";
import "../../components/task-form/theme/overrides/Button.js";
import "../../components/task-form/theme/overrides/PickersLayout.js";
import "../../components/task-form/theme/overrides/Menu.js";
import "../../components/task-form/theme/overrides/Autocomplete.js";
import "../../components/team-section/constants/constants.js";
import "../../components/team-section/components/Rating/styles.js";
import "../../components/team-section/team-section.styles.js";
import "../../components/testimonials-section/constants.js";
import "../../components/testimonials-section/PractitionerTestimonialCard/styles.js";
import "../../components/testimonials-video-section/testimonials-video-section.styles.js";
import "../../components/employee-select/employee-select.js";
import "../../components/employee-select/components/employee-search-input/employee-search-input.js";
import "../../components/employee-select/components/employee-search-input/employee-search-input.styles.js";
import "../../components/employee-select/assets/icons/Search.js";
import "../../components/employee-select/employee-select.styles.js";
import "../../components/employee-select/assets/icons/Arrow.js";
import "../../components/employee-select/assets/icons/Employees.js";
import "../../components/ana/utils/shared/Checkbox.js";
import "../../components/ana/utils/shared/FormControlLabel.js";
import "../../components/ana/components/translate/translate.js";
import "../../components/ana/components/checklist-input/checklist-input.styles.js";
import "react-dom";
import "../../components/ana/components/address-field/address-field.js";
import "formik";
import "../../components/ana/utils/helpers/getHasError.js";
import "../../components/ana/utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../components/ana/utils/helpers/googlePlaces.js";
import "../../components/ana/utils/helpers/places.js";
import "../../components/ana/utils/hooks/useFormHelpers.js";
import "../../components/ana/utils/hooks/useSubmitCount.js";
import "../../components/ana/utils/shared/TextField.js";
import "../../components/ana/utils/shared/TextFieldLabel.js";
import "../../components/ana/utils/yup/main.js";
import "../../components/ana/utils/fields/personalInformation.js";
import "../../../type/Appointment.js";
import "../../components/ana/components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../components/ana/utils/entities/Form.js";
import "../../components/ana-toolbox/ana-toolbox.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "../../components/ana/utils/helpers/toBoolean.js";
import "../../components/ana/utils/helpers/createFields.js";
import "../../components/ana/utils/helpers/resetFields.js";
import "../../components/ana/utils/yup/yup.js";
import "../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../components/ana/utils/helpers/predicates.js";
import "../../components/ana/utils/yup/emailValidation.js";
import "../../components/ana/utils/fields/contactDetails.js";
import "../../components/ana/utils/helpers/featureFlags.js";
import "../../components/ana/utils/helpers/getAgeFromBirthday.js";
import "../../components/ana/utils/yup/buildValidationSchema.js";
import "../../components/ana/utils/fields/miscellaneous.js";
import "../../components/ana/utils/fields/insurance.js";
import "../../components/ana/utils/fields/allergiesAndMedications.js";
import "../../../type/Disease.js";
import "../../components/ana/utils/config/medicaments.js";
import "../../components/ana/utils/fields/wishesAndExpectations.js";
import "../../components/ana/utils/fields/consents.js";
import "../../components/ana/utils/fields/profileInterest.js";
import "../../components/ana/components/field-helper-text/field-helper-text.js";
import "../../components/ana/components/checkbox-field/checkbox-field.styles.js";
import "../../components/ana/components/date-picker-field/date-picker-field.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../components/ana/utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../components/ana/components/date-picker-field/date-picker-field.styles.js";
import "../../components/ana/components/phone-field/phone-field.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../components/ana/utils/helpers/phoneMetadata.js";
import "../../components/ana/components/text-input/text-input.js";
import "../../components/ana/components/text-input/text-input.styles.js";
import "../../components/ana/components/phone-field/phone-field.styles.js";
import "../../components/ana/components/radio-group/radio-group.js";
import "use-deep-compare";
import "../../components/ana/utils/shared/Radio.js";
import "../../components/ana/utils/shared/RadioFormControl.js";
import "../../components/ana/utils/shared/RadioFormControlLabel.js";
import "../../components/ana/utils/shared/RadioFormLabel.js";
import "../../components/ana/utils/shared/RadioGroup.js";
import "../../components/ana/components/select-input/select-input.styles.js";
import "../../components/ana/components/toggle-field/toggle-field.js";
import "../../components/ana/utils/shared/ToggleContainer.js";
import "../../components/ana/utils/shared/ToggleFormControlLabel.js";
import "../../components/ana/utils/hooks/useFormValue.js";
import "../../components/ana/components/form-layout/form-layout.styles.js";
import "../../components/ana/utils/shared/Button.js";
import "../../components/ana/components/submit-button/submit-button.styles.js";
import "../../components/ana/components/toggle-multi-checkbox/toggle-multi-checkbox.styles.js";
import "../../components/ana/utils/config/diseases.js";
import "../../components/ana/components/insurance-field/insurance-field.js";
import "fuse.js";
import "../../components/ana/components/insurance-field/insurance-field-helpers.js";
import "../../components/ana/components/insurance-field/Insurance-field.styles.js";
import "../../components/ana/utils/shared/SectionTitle.js";
import "../../components/ana/components/callout/Callout.styles.js";
import "../../components/ana/utils/types/contentful.js";
import "../../components/ana/utils/shared/AddressLayoutItem.js";
import "../../components/ana/utils/helpers/getIsRequired.js";
import "../../components/ana/forms/miscellaneous/miscellaneous.js";
import "../../components/ana/components/form-layout/form-layout.js";
import "../../components/ana/utils/helpers/createField.js";
import "../../components/ana/components/checkbox-field/checkbox-field.js";
import "../../components/ana/components/select-field/select-field.js";
import "../../components/ana/components/select-input/select-input.js";
import "../../components/ana/components/text-field/text-field.js";
import "../../components/ana/components/submit-button/submit-button.js";
import "../../../components/loader/loader.js";
import "../../../components/loader/data.js";
import "../../../components/animation/animation.js";
import "../../../components/loader/loader.styles.js";
import "../../components/ana/utils/helpers/getFormInitialErrors.js";
import "../../components/ana/utils/config/wishes.js";
import "../../components/ana/forms/preconditions/preconditions.js";
import "../../components/ana/components/disease-group-field/disease-group-field.js";
import "../../components/ana/utils/helpers/DiseaseType.js";
import "../../components/ana/components/disease-field/disease-field.js";
import "../../components/ana/components/tag/tag.js";
import "../../components/ana/components/tag/tag.styles.js";
import "@mui/icons-material/Cancel.js";
import "../../components/ana/components/disease-field/disease-field.styles.js";
import "@mui/styles";
import "../../components/ana/components/disease-group-field/disease-group-field.helpers.js";
import "../../components/ana/components/disease-group-field/disease-group-field.styles.js";
import "../../components/ana/utils/hooks/usePreConditionsToggle.js";
import "../../components/ana/utils/helpers/scrollToElementIfNotVisible.js";
import "../../components/ana/utils/helpers/isInViewport.js";
import "../../components/ana/forms/preconditions/preconditions.styles.js";
import "../../components/ana/components/legal-representative-dialog/legal-representative-dialog.styles.js";
import "../../components/ana/utils/shared/Modal.js";
import "../../components/ana/utils/helpers/i18n.js";
import "../../components/ana/components/ana-dialog/ana-dialog.styles.js";
import "../../components/ana/utils/config/wishesAndExpectations.js";
import "../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../type/Employee.js";
import "../../../utils/array.js";
import "fast-memoize";
import "../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "../../components/website/common/button/styles.js";
import "../../components/website/jobs/job-description-section/styles.js";
import "../../components/website/jobs/job-details-hero-section/styles.js";
import "../../components/website/common/button/button.js";
import "../../../hooks/useResponsive.js";
import "../../components/smileview-section/hooks/useWindowSize.js";
import "../../components/website/directions-section/styles.js";
import "react-headroom";
import "../../components/page-header/context/header-context.js";
import "../../components/page-header/components/header-skip/styles.js";
import "../../../components/expandable/expandable-dropdown/expandable-dropdown.styles.js";
import "../../../components/expandable/expandable-group/expandable-group-context.js";
import "../../components/page-header/page-header-mobile/page-header-mobile-content/styles.js";
import "query-string";
import "../../components/authentication/components/CredentialsProvider.js";
import "../../components/authentication/config.js";
import "../../components/authentication/helpers/time.js";
import "../../components/authentication/hooks/useStickyState.js";
import "../../components/authentication/services/api.js";
import "axios";
import "../../components/authentication/helpers/credentials.js";
import "../../components/authentication/helpers/headers.js";
import "../../components/authentication/components/RouterProvider.js";
import "../../components/authentication/components/SecurityConfigProvider.js";
import "../../components/authentication/services/i18n.js";
import "../../components/authentication/components/auth-container/auth-container.styles.js";
import "@emotion/styled";
import "../../components/authentication/components/login-page/login-page.styles.js";
import "../../components/authentication/components/TrustedDeviceProvider.js";
import "../../components/authentication/components/HistoryProvider.js";
import "./components/AxiosProvider.js";
import "./components/call-patient/call-patient.js";
import "./hooks/usePhones.js";
import "../appointment-details/helpers/common.js";
import "../appointment-details/appointment-details.types.js";
import "@tanstack/react-query";
import "./components/call-patient/call-patient.styles.js";
import "./components/anamnesis-status/anamnesis-status.js";
import "./components/anamnesis-status-popover/anamnesis-status-popover.js";
import "@mui/icons-material/Refresh.js";
import "@mui/icons-material/RefreshRounded.js";
import "./helpers.js";
import "./hooks/useRecollectAnamnesis.js";
import "./hooks/useRecollectFactoringAgreement.js";
import "../../../utils/date/formatDefault.js";
import "../../../utils/date/format.js";
import "../../../utils/fp/flow/flow.js";
import "../../../utils/date/toDate.js";
import "date-fns/fp/parseISO";
import "./components/anamnesis-status-popover/anamnesis-status-popover.styles.js";
import "@mui/icons-material/CheckRounded.js";
import "@mui/icons-material/CloseRounded.js";
import "../../../components/icons/TabletIcon/TabletIcon.js";
import "./hooks/useGenerateAnamnesisCode.js";
import "./hooks/useSendAnaLinkViaSms.js";
import "../../../hooks/sse/useCodeSSE.js";
import "../../../hooks/useServerSentEvent.js";
import "../../../constants/serverSentEvents/serverSentEvents.js";
import "../../../type/InternalServerSentEvents.js";
import "./components/anamnesis-status/anamnesis-status.styles.js";
import "./assets/icons/AnamnesisAttention.js";
import "./assets/icons/AnamnesisDone.js";
import "./assets/icons/AnamnesisInProgress.js";
import "./components/appointment-status-select/appointment-status-select.js";
import "react-hook-form";
import "./assets/icons/Cancel.js";
import "./assets/icons/Controlled.js";
import "./assets/icons/InClinic.js";
import "./assets/icons/InTreatment.js";
import "./assets/icons/NotInClinic.js";
import "./assets/icons/TreatmentComplete.js";
import "./assets/icons/TreatmentRoom.js";
import "./assets/icons/Waiting.js";
import "../../../hooks/useDidUpdate.js";
import "../../../utils/time/time.js";
import "./hooks/useStatusChange.js";
import "./components/appointment-status-select/appointment-status-select.helpers.js";
import "./room-provider.js";
import "./components/appointment-status/appointment-status.js";
import "./assets/icons/ControlledCheckIcon.js";
import "./assets/icons/ControlledDoubleCheckIcon.js";
import "./assets/icons/Open.js";
import "./components/appointment-status/appointment-status.styles.js";
import "./components/appointment-status-controlled/appointment-status-controlled.js";
import "react-imask";
import "./components/appointment-status-select/appointment-status-select.styles.js";
import "@mui/icons-material";
import "./components/appointment-status-select/appointment-status-select.constants.js";
import "./components/appointment-status-controlled/appointment-status-controlled.styles.js";
import "./components/appointment-status-radio/appointment-status-radio.js";
import "./components/room-select/room-select.js";
import "./components/room-select/room-select.styles.js";
import "./components/appointment-status-radio/appointment-status-radio.styles.js";
import "./components/care-level/care-level.js";
import "./components/care-level/care-level.styles.js";
import "./assets/icons/TrustIcon.js";
import "./components/credit-worthiness-status/credit-worthiness-status.js";
import "../../components/credit-worthiness-tooltip/credit-worthiness-tooltip.js";
import "../../components/credit-worthiness-tooltip/credit-worthiness-tooltip.styles.js";
import "./components/credit-worthiness-status/credit-worthiness-status.styles.js";
import "./assets/icons/CreditWorthinessIcon.js";
import "./components/insurance-proof/insurance-proof.js";
import "./components/insurance-proof/insurance-proof.styles.js";
import "./assets/icons/InsuranceProofIcon.js";
import "./components/patient-today-list-item/patient-today-list-item.styles.js";
import "../open-appointments-list/open-appointments-list.types.js";
import "../../../hooks/sse/useAnamnesisSSE.js";
import "../../../hooks/sse/useAppointmentSSE.js";
import "../../../hooks/sse/usePatientSSE.js";
const getFormattedDate = (date = /* @__PURE__ */ new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const getInitialSelectedStatuses = () => {
  return Object.values(AppointmentStatusFilter).map((status) => {
    return {
      status,
      isSelected: false
    };
  });
};
const PatientTodayListComponent = ({
  baseURL,
  clinicReferenceId,
  isObfuscated = false,
  auth,
  showCreditWorthinessStatus,
  showAna,
  onAppointmentClick,
  onPatientClick,
  onPatientCall,
  heightCSS,
  useWindowScrollForVirtualizedList,
  createPatientLink,
  openedPatientExternalId
}) => {
  const today = /* @__PURE__ */ new Date();
  const [selectedDay, setSelectedDay] = useLocalStorageProperly(
    `${clinicReferenceId}_selectedDay`,
    today.toISOString()
  );
  const selectedDayDate = selectedDay ? new Date(selectedDay) : today;
  const { practitioners, setPractitioners } = usePractitioners(
    {
      clinicReferenceId,
      status: `${EmployeeStatus.ACTIVE},${EmployeeStatus.WILL_BE_ACTIVE},${EmployeeStatus.USED_TO_BE_ACTIVE},${EmployeeStatus.DISABLED},${EmployeeStatus.INACTIVE}`
    },
    auth,
    baseURL
  );
  const { labels } = useLabels();
  const [selectedStatuses, setSelectedStatuses] = useLocalStorageProperly(
    `${clinicReferenceId}_selectedStatuses`,
    getInitialSelectedStatuses()
  );
  const practitionerReferenceIds = practitioners ? selectedPractitionersSelector(practitioners) : "";
  const { data: patientTodayListData, queryKey } = usePatientTodayList(!!practitioners, {
    date: getFormattedDate(selectedDayDate),
    clinicReferenceId,
    practitionerReferenceIds,
    statuses: selectedStatuses ? selectedStatusesSelector(selectedStatuses) : ""
  });
  const sortedListData = useMemo(
    () => patientTodayListData == null ? void 0 : patientTodayListData.slice().sort((a, b) => {
      const aDateTime = new Date(a.appointment.appointmentStart).getTime();
      const bDateTime = new Date(b.appointment.appointmentStart).getTime();
      if (aDateTime === bDateTime) {
        return (a.appointment.risky ? 1 : 0) - (b.appointment.risky ? 1 : 0);
      }
      return aDateTime - bDateTime;
    }),
    [patientTodayListData]
  );
  const handlePractitionerUpdate = (practitioners2) => {
    setPractitioners(practitioners2);
  };
  const handleDateUpdate = (date) => {
    setSelectedDay(date ? new Date(date).toISOString() : today.toISOString());
  };
  const handleOnStatusUpdate = (statuses) => {
    setSelectedStatuses(statuses);
  };
  return /* @__PURE__ */ jsx(QueryKeyProvider, { queryKey, children: /* @__PURE__ */ jsx(
    PatientTodayList,
    {
      data: sortedListData ? patientTodayListSelector(sortedListData, isObfuscated, { patientNameFallback: labels == null ? void 0 : labels.unknownPatient }) : [],
      onPatientClick,
      createPatientLink,
      onDateUpdate: handleDateUpdate,
      onPatientCall,
      onPractitionerUpdate: handlePractitionerUpdate,
      onStatusUpdate: handleOnStatusUpdate,
      onAppointmentClick,
      selectedDay: selectedDayDate,
      practitioners,
      selectedStatuses,
      clinicReferenceId,
      useWindowScrollForVirtualizedList,
      showAna,
      showCreditWorthinessStatus,
      heightCSS,
      openedPatientExternalId
    }
  ) });
};
const PatientTodayListContainer = withPatientTodayListProviders(PatientTodayListComponent);
export {
  PatientTodayListComponent,
  PatientTodayListContainer
};
